import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Package} from "../../../model/package";

@Component({
  selector: 'app-package-container',
  templateUrl: './package-container.component.html',
  styleUrls: ['./package-container.component.css']
})
export class PackageContainerComponent implements OnInit {

  infos='MEHR INFOS';
  mobile: boolean = false;

  constructor() { }

  @Input() packages: Array<Package>;
  @Output() packageSelect = new EventEmitter();
  @Output() infoRequest = new EventEmitter();


  ngOnInit(): void {
    if  (window.screen.width <= 1000) { // 768px portrait
      this.mobile = true;
    }
  }

  selectPackage(event){
    this.packageSelect.emit(event)
    this.packages.forEach(function (p) {
        p.selected = p.name === event;
      }
    )
  }

}
